import React from 'react';
import '../Details.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";
import BarChart from './BarChart';
import { useEffect, useState,useRef } from 'react';
function OrderManagement ({periodSelection}) {
  return (
    <div className="details-container-page">
     <BarChart title="A Chart  4" periodSelection={periodSelection}  height={600}  hasAdvancedOptions={true}/>
    </div>
  );
}

export default OrderManagement  ;
